import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, submissionViewModel) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    var OPTIONAL_ITEMS = ['roomerBoarders', 'unitsNumber', 'fireplaceOrWoodStoveExists', 'swimmingPoolExists', 'trampolineExists', 'knownWaterLeakage'];

    /**
     * Checks if any of additional fields is set
     * @returns {boolean}
     */
    function isAnyAdditionalField() {
        return OPTIONAL_ITEMS.some(function (itemName) {
            return $scope.view[itemName] && $scope.view[itemName].value !== undefined;
        });
    }

    ctrl.init = function () {
        /* Rating object */
        $scope.view = submissionVM.lobData.homeowners.coverables.rating;
        $scope.view.value = $scope.view.value || {};

        /* Additional fields */
        $scope.isAdditionalOpen = isAnyAdditionalField();
    };

    ctrl.next = function (nextFn) {
        if (!$scope.view.deadbolts.value) {
            // clear any previously existing value for the amount
            $scope.view.deadboltsNumber.value = undefined;
        }
        nextFn(submissionVM);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/controllers/HORatingCtrl.js
// module id = 2151
// module chunks = 0